import script from "./TrainingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrainingPage.vue?vue&type=script&setup=true&lang=ts"

import "./TrainingPage.vue?vue&type=style&index=0&id=42b4186f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42b4186f"]])

export default __exports__